import React from "react";
import styles from "./peopleSearchResults.module.css";
import { Link } from "react-router-dom";

const PeopleSearchResults = ({
  searchResults,
  learnedLanguage,
  offeredLanguage,
}) => {
  /* This component is responsible for displaying search results of users. It is used by the SearchPeople component on the Search page. For each user in the result, the username, profile image, and requested type of cooperation are shown, and there is a link to the user's profile page. */

  const peopleList = searchResults.map((person) => (
    <div key={person.username} className={styles.personResult}>
      <Link to={`/profile/${person.username}`} target="_blank">
        <figure>
          <img src={person.img_link} alt={person.username} />
          <figcaption>{person.username}</figcaption>
        </figure>
      </Link>
      <div>
       
          {person.cooperation_type === "Exchange"
            ? `Language Exchange: ${learnedLanguage}/ ${offeredLanguage}`
            : person.cooperation_type === "Together"
            ? `Learn Together: ${learnedLanguage}`
            : `Searched User`}
        
      </div>
    </div>
  ));

  return (
    <div className={styles.searchResults}>
      <h2>Search Results</h2>
      <p>
        We found {searchResults.length} people that match your search criteria:
      </p>
      {peopleList}
    </div>
  );
};

export default PeopleSearchResults;
